import { Vector3 } from "three";

export type LastSavedPointsCache = Map<number, Vector3[]>;

export function recordLastSavedPoints(
  cache: LastSavedPointsCache,
  id: number,
  points: Vector3[]
): void {
  cache.set(id, points.map((p) => p.clone()));
}

export function syncLastSavedPointsFromMeasurements(
  cache: LastSavedPointsCache,
  measurements: Iterable<{ id: number; _points: Vector3[] }>
): void {
  for (const measurement of measurements) {
    recordLastSavedPoints(cache, measurement.id, measurement._points);
  }
}

export function snapshotMeasurementPoints(
  measurements: Iterable<{ id: number; _points: Vector3[] }>
): { id: number; _points: Vector3[] }[] {
  const snapshot: { id: number; _points: Vector3[] }[] = [];
  for (const measurement of measurements) {
    snapshot.push({
      id: measurement.id,
      _points: measurement._points.map((p) => p.clone()),
    });
  }
  return snapshot;
}
